import React, { useEffect, useState } from 'react';
import { serverUrl } from '../../../Constant/Static/config';
import prevIcon from '../../../Constant/Icons/leftarrow.svg';
import nextIcon from '../../../Constant/Icons/rightarrow.svg';

function ApplicationD() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(`${serverUrl}/api/admin/records?page=${page}&pageSize=${pageSize}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    const result = await response.json();
                    setData(result.data);
                    setTotalPages(result.totalPages);
                } else {
                    throw new Error('Received non-JSON response');
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        if (pageSize > 0) {
            fetchData();
        }
    }, [page, pageSize]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return (
        <div className='student-table-wrapper'>
            <div className='student-table-container'>
                {error && <div>Error: {error}</div>}
                <table className='student-responsive-table'>
                    <thead>
                        <tr>
                            <th>S No.</th>
                            <th>Application No.</th>
                            <th>Applicant Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>Status</th>
                            <th>More...</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row.APPLN_NO}</td>
                                <td>{row.APPLICANT_NAME}</td>
                                <td>{row.EMAIL}</td>
                                <td>{row.MOBILE}</td>
                                <td>{row.SUBMIT}</td>
                                <td><button>Click Here..</button></td>
                                {/* Render other columns */}
                            </tr>
                        ))}
                    </tbody>
                </table>
                {loading && <div>Loading...</div>}
            </div>
            <div className='pagination'>
                <button onClick={() => handlePageChange(page - 1)} disabled={page === 1 || loading}>
                    <img src={prevIcon} width={15} height={15} alt="Back" />
                </button>
                <span>
                    {page} of {totalPages}
                </span>
                <button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages || loading}>
                    <img src={nextIcon} width={15} height={15} alt="Back" />
                </button>
            </div>
        </div>
    );
}

export default ApplicationD;